import React from "react";
import { Text } from "react-native";
import {
  KulimPark_200ExtraLight,
  KulimPark_200ExtraLight_Italic,
  KulimPark_300Light,
  KulimPark_300Light_Italic,
  KulimPark_400Regular,
  KulimPark_400Regular_Italic,
  KulimPark_600SemiBold,
  KulimPark_600SemiBold_Italic,
  KulimPark_700Bold,
  KulimPark_700Bold_Italic,
  useFonts,
} from "@expo-google-fonts/kulim-park";

export const loadFonts = () => {
  let [loaded, error] = useFonts({
    KulimPark_400Regular,
    KulimPark_600SemiBold,
    KulimPark_700Bold,
    KulimPark_300Light,
  });
  applyFont();
  return loaded;
};

export const applyFont = () => {
  const oldRender = Text.render;
  Text.render = function (...args) {
    const origin = oldRender.call(this, ...args);
    return React.cloneElement(origin, {
      style: [{ fontFamily: "KulimPark_400Regular" }, origin.props.style],
    });
  };
};
